import { render, staticRenderFns } from "./HighwayList.vue?vue&type=template&id=7587a152"
import script from "./HighwayList.vue?vue&type=script&lang=js"
export * from "./HighwayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports